import { startOfDay } from 'date-fns';

import { formatDateKey, parseDateKey } from './format-date-key';

const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;

const pad = (value: number) => String(value).padStart(2, '0');

export const formatNaiveCalendarDateTime = (
  date: Date,
  timeOfDayMs: number,
) => {
  const totalSeconds = Math.floor(timeOfDayMs / MS_PER_SECOND);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  const totalMinutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const minutes = totalMinutes % MINUTES_PER_HOUR;
  const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);

  return `${formatDateKey(date)}T${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

// Fails soft: a value without a time part, or with a non-numeric one, reads as midnight.
export const parseNaiveCalendarDateTime = (value: string) => {
  const [datePart, timePart = ''] = value.split('T');
  const [hours = 0, minutes = 0, seconds = 0] = timePart.split(':').map(Number);
  const timeOfDayMs =
    (((hours || 0) * MINUTES_PER_HOUR + (minutes || 0)) * SECONDS_PER_MINUTE +
      (seconds || 0)) *
    MS_PER_SECOND;

  return { date: startOfDay(parseDateKey(datePart)), timeOfDayMs };
};
